export const shouldShowMobileStickyHeaderRct = () =>
	$('#__rctMobileStickyHeader').length && window?.SellerAppDashboard;

export const isMobileStickyHeaderRctLoaded = () =>
	$(`#__rctMobileStickyHeader`).children().length;

export let MobileStickyHeaderRctDispatcher = null;

export function loadMobileStickyHeaderRct(project) {
	if (!isMobileStickyHeaderRctLoaded()) {
		window.SellerAppDashboard.launchModule(
			'lead-details-mobile-header',
			'__rctMobileStickyHeader',
			{
				onClickBack: onClickMobileHeaderBackBtn,
				onClickPass: onClickMobileHeaderPassBtn,
				onMount: (dispatch) => {
					MobileStickyHeaderRctDispatcher = dispatch;
					setMobileStickyHeaderRctState(project);
				},
			},
		);
	} else {
		setMobileStickyHeaderRctState(project);
	}
}

export function setMobileStickyHeaderRctState(project) {
	if (MobileStickyHeaderRctDispatcher) {
		MobileStickyHeaderRctDispatcher({
			type: 'setBuyerName',
			value: project.buyer_share_name,
		});

		MobileStickyHeaderRctDispatcher({
			type: 'setAvatarColor',
			value: project.bg_color,
		});
	}
}

export function setMobileStickyHeaderRctMinimized(value) {
	if (MobileStickyHeaderRctDispatcher) {
		MobileStickyHeaderRctDispatcher({
			type: 'setIsMinimized',
			value: value,
		});
	}
}

export function toggleMobileStickyHeaderView() {
	const $stickyHeader = $('#__rctMobileStickyHeader');
	const $projectDetails = $('#__rctProjectDetailsLeadDetails');
	$projectDetails.offset().top + $projectDetails.outerHeight() <
	$stickyHeader.offset().top + $stickyHeader.outerHeight()
		? setMobileStickyHeaderRctMinimized(true)
		: setMobileStickyHeaderRctMinimized(false);
}

export function setMobileStickyHeaderRctShowPassBtn(value) {
	if (MobileStickyHeaderRctDispatcher) {
		MobileStickyHeaderRctDispatcher({
			type: 'setShowPassBtn',
			value: value,
		});
	}
}

export function onClickMobileHeaderBackBtn() {
	//Existing code from seller_dashboard.js
	const sellerEnquiriesBanner = $('#__rctSellerEnquiriesBanner');
	const barkHeader = $('.bark-header');
	sellerEnquiriesBanner.removeClass('d-none');
	if (
		$('#__rctSellerEnquiriesBanner').length &&
		!!$('#__rctSellerEnquiriesBanner').html().length
	) {
		// if review banner is present on mobile remove stickiness
		if (
			$('#__rctSellerEnquiriesBanner > .tw-sticky >[aria-label="review-banner"]').length
		) {
			barkHeader.css('top', 0);
		} else {
			barkHeader.css('top', $('#__rctSellerEnquiriesBanner').height());
		}
	}
	if (Bark.seller.interactingWithProject) {
		return false;
	}
	Bark.seller.hideProject();
	Bark.setPageState({ projectId: 0 }, null, true);
	Bark.seller.processNoRecords();
}

export function onClickMobileHeaderPassBtn() {
	//Existing code from seller_dashboard.js
	var projectId = $('.dashboard-project-details').attr('data-project-id');
	if (!projectId) {
		return false;
	}
	if ($('.seller-dash-v2 .calls-to-action .not-interested').hasClass('shortlisted')) {
		$('#confirmNotInterested').modal('show');
	} else {
		Bark.seller.processNotInterested(projectId);
	}
}
